export default __webpack_public_path__ + "static/media/21.ffe8d86a.mp3";